import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      states: {
        Initial: {
          label: "Call",
          message: "Ready to call",
        },
        RetrievingSetup: {
          label: "Cancel",
          message: "Retrieving setup information...",
        },
        Connecting: {
          label: "Cancel",
          message: "Connecting...",
        },
        Ringing: {
          label: "Cancel",
          message: "Ringing...",
        },
        Connected: {
          label: "End call",
          message: "Connected!",
        },
        Disconnected: {
          label: "Call again",
          message: "Disconnected from call",
        },
        Cancelled: {
          label: "Call again",
          message: "Call cancelled",
        },
        Error: {
          label: "Call again",
          message: "An error occurred, please try again",
        },
      },
    },
  },
  es: {
    translation: {
      states: {
        Initial: {
          label: "Llamar",
          message: "Listo para llamar",
        },
        RetrievingSetup: {
          label: "Cancelar",
          message: "Recuperando información de configuración...",
        },
        Connecting: {
          label: "Cancelar",
          message: "Conectando...",
        },
        Ringing: {
          label: "Cancelar",
          message: "Llamando...",
        },
        Connected: {
          label: "Finalizar llamada",
          message: "¡Conectado!",
        },
        Disconnected: {
          label: "Volver a llamar",
          message: "Desconectado de la llamada",
        },
        Cancelled: {
          label: "Volver a llamar",
          message: "Llamada cancelada",
        },
        Error: {
          label: "Volver a llamar",
          message: "Ocurrió un error, por favor intente de nuevo",
        },
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    load: "languageOnly",
    debug: true,
    detection: {
      order: ["cookie", "navigator"],
      lookupCookie: "lang",
      caches: ["cookie"],
    },
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
